export const SET_SEARCH_PAGE_DATA = 'SET_SEARCH_PAGE_DATA';
export const SET_DISPLAY_NAMES_LOOKUP = 'SET_DISPLAY_NAMES_LOOKUP';
export const SET_OPEN_FILTER = 'SET_OPEN_FILTER';
export const SET_PREV_FILTER = 'SET_PREV_FILTER';
export const UPDATE_REQUEST = 'UPDATE_REQUEST';
export const UPDATE_RESULTS = 'UPDATE_RESULTS';
export const UPDATE_ERROR = 'UPDATE_ERROR';
